<div class="widget-title">Average Purchase Price</div>
<div class="chartContainer">
    <div *ngIf="hasData && !noData" class="averagePriceTotal">{{ formattedAvgPrice }}</div>
    <div *ngIf="hasData && !noData" class="highestPrice">{{ formattedHighPrice }}</div>
    <div *ngIf="hasData && !noData" class="footer">Highest Purchase Price</div>
    <div *ngIf="hasData && noData" class="noData pad">No Data Available</div>
</div>